<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        {{ aLang.c_list }} Văn bản
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <div class="text-left">
          <b-collapse
            v-bind:visible="mData.tableRules.showFormSearch"
            id="myFormSearch"
          >
            <b-card>
              <el-form
                ref="myForm"
                label-position="top"
                @submit.native.prevent
                :model="mData.tableRules.dataSearch.value"
                :rules="mData.tableRules.dataSearch.valid"
              >
                <el-row :gutter="20">
                  <el-col :md="6">
                    <el-form-item label="Loại văn bản/hợp đồng">
                      <el-select
                        v-model="mData.tableRules.dataSearch.value.type"
                        placeholder="Chọn loại văn bản/hợp đồng"
                        clearable
                      >
                        <el-option
                          v-for="item in mData.typeVanBan"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :md="6">
                    <el-form-item label="Số văn bản/hợp đồng">
                      <el-input
                        v-model="mData.tableRules.dataSearch.value.code"
                        clearable
                        placeholder="Nhập số văn bản/hợp đồng"
                      />
                    </el-form-item>
                  </el-col>
                  <!-- <b-col md="6">
                    <el-form-item :label="aLang.tt_tour_name" prop="tour_id">
                      <el-autocomplete
                        clearable
                        class="inline-input"
                        v-model="ten_tour"
                        :fetch-suggestions="querySearch"
                        :placeholder="aLang.tt_enter_keywords_to_search"
                        :trigger-on-focus="false"
                        @select="handleSelect"
                        @change="handleSelect"
                        style="width: 100%"
                      >
                        <template slot-scope="{ item }">
                          <span class="link">{{ item.ten_tour }}</span>
                        </template>
                      </el-autocomplete>
                    </el-form-item>
                  </b-col> -->
                  <el-col :md="6">
                    <el-form-item
                      label="Số thẻ hướng dẫn viên"
                      prop="huong_dan_vien_id"
                    >
                      <el-autocomplete
                        clearable
                        class="inline-input"
                        v-model="hdv_so_the"
                        :fetch-suggestions="querySearchHuongDanVienST"
                        placeholder="Nhập số thẻ của hướng dẫn viên"
                        :trigger-on-focus="false"
                        @select="handleSelectHuongDanVienST"
                        @change="handleSelectHuongDanVienST"
                        style="width: 100%"
                      >
                        <template slot-scope="{ item }">
                          <span class="link">{{
                            item.ho_ten.ho_ten +
                            " - số thẻ " +
                            item.the_hdv.so_the
                          }}</span>
                        </template>
                      </el-autocomplete>
                      <!-- end test autocomplete -->
                    </el-form-item>
                  </el-col>
                  <el-col :md="6">
                    <el-form-item
                      label="Số giấy tờ hướng dẫn viên"
                      prop="huong_dan_vien_id"
                    >
                      <el-autocomplete
                        clearable
                        class="inline-input"
                        v-model="hdv_so_giay_to"
                        :fetch-suggestions="querySearchHuongDanVienSGT"
                        placeholder="Nhập số giấy tờ của hướng dẫn viên"
                        :trigger-on-focus="false"
                        @select="handleSelectHuongDanVienSGT"
                        @change="handleSelectHuongDanVienSGT"
                        style="width: 100%"
                      >
                        <template slot-scope="{ item }">
                          <span class="link">{{
                            item.ho_ten.ho_ten +
                            " - số giấy tờ: " +
                            item.giay_to[0].so_giay_to
                          }}</span>
                        </template>
                      </el-autocomplete>
                      <!-- end test autocomplete -->
                    </el-form-item>
                  </el-col>
                  <!-- <b-col md="3">
                    <el-form-item
                      :label="aLang.tt_start_time"
                      prop="thoi_gian_bat_dau"
                      :error="fn_compareTime()"
                    >
                      <el-date-picker
                        type="date"
                        :format="aElement.datepicker.formatDate"
                        :valueFormat="aElement.datepicker.valueFormat"
                        v-model="
                          mData.tableRules.dataSearch.value.thoi_gian_bat_dau
                        "
                        :placeholder="aElement.datepicker.placeholderDate"
                        clearable
                      ></el-date-picker>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item
                      :label="aLang.tt_end_time"
                      prop="thoi_gian_ket_thuc"
                      :error="fn_compareTime()"
                    >
                      <el-date-picker
                        type="date"
                        :format="aElement.datepicker.formatDate"
                        :valueFormat="aElement.datepicker.valueFormat"
                        v-model="
                          mData.tableRules.dataSearch.value.thoi_gian_ket_thuc
                        "
                        :placeholder="aElement.datepicker.placeholderDate"
                        clearable
                      ></el-date-picker>
                    </el-form-item>
                  </b-col> -->
                </el-row>
                <el-form-item class="text-center mb-0">
                  <el-button
                    type="info"
                    native-type="submit"
                    v-ladda
                    plain
                    @click="fn_tableSearch()"
                    >{{ aLang.c_search }}</el-button
                  >
                </el-form-item>
              </el-form>
            </b-card>
          </b-collapse>
        </div>
        <b-row>
          <b-col md="8" class="p-0">
            <b-col md="4"></b-col>
          </b-col>
          <b-col md="4">
            <div class="text-right mb-2">
              <el-button @click="fn_tableShowFormSearch()" type="info" plain>{{
                aLang.c_showHideSearch
              }}</el-button>
              <el-button
                @click="fn_handle('create')"
                type="info"
                v-if="aRole('TourAgent')"
                plain
                >{{ aLang.c_create }}</el-button
              >
            </div>
          </b-col>
        </b-row>

        <el-table
          :data="mData.tableRules.data"
          border
          @selection-change="fn_tableSelectionChange"
          @sort-change="fn_tableSortChange"
          max-height="440"
          style="width: 100%"
          :default-sort="{
            prop: mData.tableRules.defaultSort[0],
            order: mData.tableRules.defaultSort[1],
          }"
        >
          <el-table-column
            type="selection"
            width="40"
            v-if="mData.tableRules.allowSelect"
          ></el-table-column>
          <el-table-column
            prop="thoi_gian_tao"
            :sortable="mData.tableRules.allowSorting"
            label="Thời gian tạo"
            :formatter="fn_formatterDatetime"
            width="160"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="code"
            :sortable="mData.tableRules.allowSorting"
            label="Số"
            width="140"
            align="center"
          ></el-table-column>
          <el-table-column prop="type" label="Loại" width="150" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.type === 'hdld'">Hợp đồng lao động</span>
              <span v-else>Phiếu điều tour</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            :sortable="mData.tableRules.allowSorting"
            label="Tên văn bản/hợp đồng"
            min-width="300"
            align="left"
          ></el-table-column>
          <!-- <el-table-column
            prop="tour_id"
            :label="aLang.tt_tour_name"
            min-width="200"
          >
            <template slot-scope="scope">
              <el-link
                class="cell-child"
                target="_blank"
                @click="fn_handle('detail', scope.$index, scope.row)"
                :underline="false"
                >{{ scope.row.ten_tour }}</el-link
              >
            </template>
          </el-table-column> -->
          <el-table-column
            prop="ten_huong_dan_vien"
            label="Hướng dẫn viên"
            width="200"
          ></el-table-column>
          <el-table-column
            prop="status"
            label="Trạng thái"
            width="130"
            align="center"
          >
            <template slot-scope="scope">
              <span :class="'status-tag ' + 'status-' + scope.row.status">
                {{ renderStatus(scope.row.status) }}
              </span>
            </template>
          </el-table-column>

          <el-table-column :label="aLang.c_action" align="center" width="150px">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="fn_handle('view-file', scope.$index, scope.row)"
                v-b-popover.hover.left="'Xem văn bản/hợp đồng'"
              >
                <i class="fa fa-file-pdf"></i>
              </el-button>
              <!-- <el-button
                size="mini"
                @click="fn_handle('delete', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_delete"
                v-if="aRole('TourAgent')"
              >
                <i class="icon-trash icons"></i>
              </el-button> -->
            </template>
          </el-table-column>
        </el-table>

        <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
          <div class="col-md-4">
            <div v-if="mData.tableRules.allowSelect">
              {{ aLang.c_select }}: {{ mData.tableRules.recordSelected.length }}
            </div>
          </div>
          <div class="col-md-8 text-right">
            <el-pagination
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
              :page-sizes="mData.tableRules.lengthMenu"
              :page-size="mData.tableRules.limit"
              :current-page="mData.tableRules.page"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="mData.tableRules.total"
              :pager-count="5"
            ></el-pagination>
          </div>
        </b-row>
      </div>
    </div>
    <el-dialog
      title="Chi tiết văn bản/hợp đồng"
      :visible.sync="showPopup"
      class="iframe-dialog"
      top="5vh"
    >
      <el-select
        v-model="tenHopDongDaKy"
        placeholder="Chọn văn bản/hợp đồng"
        v-if="danhSachHopDongDaKy.length > 0"
        @change="handleChangeHopDong"
        @before-close="closeDialog"
        style="width: 300px; margin: 10px 0 10px 10px"
      >
        <el-option
          v-for="item in danhSachHopDongDaKy"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <iframe
        :src="urlHopDong"
        frameborder="0"
        class="iframe-contract"
      ></iframe>
    </el-dialog>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import QuanLyVanBanModel from "./QuanLyVanBanModel";
import mushroom from "../../../service/api/dulich-api";
import ExtensionService from "../../../service/ExtensionService";
export default {
  data() {
    return {
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        moduleName: "QuanLyVanBan", //requied
        tableRules: MethodService.copyObject(QuanLyVanBanModel.tableRules),
        typeVanBan: QuanLyVanBanModel.typeVanBan,
        dataDefault: {
          roles: DataService.roles,
          listCongTyLuHanh: [],
          listTour: [],
          listHuongDanVien: [],
          listFindTour: [],
          listFindHuongDanVien: [],
          validErrorTime: false,
        },
      },
      ten_tour: undefined,
      hdv_so_the: undefined,
      hdv_so_giay_to: undefined,
      showPopup: false,
      tenHopDongDaKy: undefined,
      danhSachHopDongDaKy: [],
      urlHopDong: undefined,
    };
  },

  methods: {
    closeDialog() {
      this.tenHopDongDaKy = undefined;
      this.danhSachHopDongDaKy = [];
      this.urlHopDong = undefined;
    },
    renderStatus(status) {
      if (status == "draft") return "Đang trình ký";
      if (status == "signing") return "Chờ HDV ký";
      if (status == "signed") return "Đã ký";
      if (status == "cancelled") return "Hủy";
      if (status == "rejected") return "HDV từ chối";
      return "";
    },
    async querySearch(queryString, cb) {
      queryString = queryString.trim();
      if (!queryString) {
        return;
      }

      var q1 = queryString
        .replace("*", "\\*")
        .replace("$", "\\$")
        .replace("%", "\\*")
        .replace("[", "\\[")
        .replace("]", "\\]")
        .replace("^", "\\^");
      let res = await mushroom.tour.getAllAsync({
        filters: `ten_tour:regex_i:${q1}`,
      });

      var results = queryString
        ? res.result.filter((item) =>
            item.ten_tour.toLowerCase().includes(queryString.toLowerCase())
          )
        : res.result;
      // call callback function to return suggestions
      cb(results);
    },
    handleSelect(item) {
      this.mData.tableRules.dataSearch.value.tour_id = item.id;
      this.ten_tour = item.ten_tour;
    },
    async querySearchHuongDanVienST(queryString, cb) {
      queryString = queryString.trim();
      let resHuongDanVienApi = await mushroom.huong_dan_vien.listAsync({
        filters: `the_hdv.trang_thai=true&the_hdv.so_the=${encodeURIComponent(
          queryString
        )}`,
      });

      var results = queryString
        ? resHuongDanVienApi.result.filter((item) =>
            item.the_hdv.so_the.includes(queryString)
          )
        : resHuongDanVienApi.result;
      cb(results);
    },
    handleSelectHuongDanVienST(item) {
      this.hdv_so_the =
        (item.ho_ten && item.ho_ten.ho_ten) != null ? item.ho_ten.ho_ten : "";

      this.mData.tableRules.dataSearch.value.huong_dan_vien_id = item.id;
    },
    async querySearchHuongDanVienSGT(queryString, cb) {
      queryString = queryString.trim();
      let resHuongDanVienApi = await mushroom.huong_dan_vien.listAsync({
        filters: `the_hdv.trang_thai=true&giay_to.so_giay_to=${encodeURIComponent(
          queryString
        )}`,
      });

      var results = queryString
        ? resHuongDanVienApi.result.filter((item) =>
            item.giay_to[0].so_giay_to.includes(queryString)
          )
        : resHuongDanVienApi.result;
      cb(results);
    },
    handleSelectHuongDanVienSGT(item) {
      this.hdv_so_giay_to =
        (item.ho_ten && item.ho_ten.ho_ten) != null ? item.ho_ten.ho_ten : "";
      this.mData.tableRules.dataSearch.value.huong_dan_vien_id = item.id;
    },
    async changeData(data) {
      const hdvIds = data.map((d) => d.huong_dan_vien_id);
      let resHDV = await mushroom.huong_dan_vien.listAsync({
        filters: ["id:in:" + hdvIds],
      });
      console.log("resssss", resHDV);

      data.forEach((d) => {
        let touragent = null;
        if (d.history && d.history.length) {
          touragent = d.history.find((h) => h.type === "touragent_signed");
        }
        d.thoi_gian_tao = touragent ? touragent.time : null;

        const hdv = ((resHDV && resHDV.result) || []).find((res) => {
          return res.id === d.huong_dan_vien_id;
        });
        if (hdv && hdv.ho_ten && hdv.ho_ten.ho_ten) {
          d.ten_huong_dan_vien = hdv.ho_ten.ho_ten;
        } else d.ten_huong_dan_vien = null;
      });

      return data;
    },
    async fn_initTable() {
      const { tableRules } = this.mData;
      const dataFilter = {
        filters: tableRules.filters,
        ...(tableRules.allowPaging && {
          limit: tableRules.limit,
          offset: tableRules.offset,
        }),
        ...(tableRules.allowSorting && { sort: tableRules.sort }),
      };

      if (tableRules.showUrl) {
        this.$router.replace({
          name: "Admin-QuanLyVanBan-list",
          query: {
            limit: tableRules.limit,
            page: tableRules.page,
            sort: tableRules.sort,
            filters: tableRules.filters,
            showFormSearch: tableRules.showFormSearch,
          },
        });
      }

      const res = await mushroom.hddt_document.listAsync({
        fields:
          "id,type,cong_ty_lu_hanh_id,huong_dan_vien_id,name,status,code,sidoc,url,final_file_id,final_files,history",
        ...dataFilter,
      });

      tableRules.data = await this.changeData(res.result);
      tableRules.total = res.meta.total;
      tableRules.page = res.meta.offset / res.meta.limit + 1;
    },
    handleChangeHopDong(idFile) {
      this.urlHopDong = ExtensionService.urlImg + idFile;
    },
    async getUrlHopDong(idFile) {
      const response = await mushroom.hddt_document.get_view_document_urlAsync({
        body: { id: idFile },
      });
      return response.result.url || undefined;
    },
    //click button
    async fn_handle(type, scope, row) {
      if (type == "create") {
        this.$router.push({
          name: "Admin-QuanLyVanBan-create",
        });
      }
      if (type == "view-file") {
        let infoFile = undefined;
        if (row.status === "signed") {
          this.danhSachHopDongDaKy = (row.final_files || []).map((item) => ({
            value: item.file_id,
            label: item.name,
          }));
          this.tenHopDongDaKy = this.danhSachHopDongDaKy[0].label || undefined;
          infoFile = this.danhSachHopDongDaKy[0].value
            ? ExtensionService.urlImg + this.danhSachHopDongDaKy[0].value
            : undefined;
        } else infoFile = await this.getUrlHopDong(row.id);

        if (!infoFile) {
          window.toastr.warning("Không có thông tin file văn bản/hợp đồng.");
          return;
        }

        this.showPopup = true;
        this.urlHopDong = infoFile;
      }
    },

    fn_tableSelectionChange(val) {
      var _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function (element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    // search
    fn_tableSearch() {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid && !this.mData.dataDefault.validErrorTime) {
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";
          this.fn_initTable();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch =
        !this.mData.tableRules.showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-QuanLyVanBan-list",
        query: query,
      });
    },

    async fn_findTour(query) {
      query = query.trim();
      if (!query) {
        return;
      }

      var q1 = query
        .replace("*", "\\*")
        .replace("$", "\\$")
        .replace("%", "\\*")
        .replace("[", "\\[")
        .replace("]", "\\]")
        .replace("^", "\\^");
      let res = await mushroom.tour.getAllAsync({
        filters: `ten_tour:regex_i:${q1}`,
      });
      this.mData.dataDefault.listFindTour = res.result;
    },

    fn_formatterDate(row, column, cellValue) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    fn_formatterRoles(row, column, cellValue) {
      var roles = "";
      cellValue.forEach((item) => {
        for (let i = 0; i < this.mData.dataDefault.roles.length; i++) {
          if (item == this.mData.dataDefault.roles[i].value) {
            item = this.mData.dataDefault.roles[i].label;
            roles += item + " ,";
          }
        }
      });
      roles = roles.slice(0, -1);
      return roles;
    },

    async fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }

      //add value to form search
      if (this.mData.tableRules.dataSearch.value.tour_id) {
        let res = await mushroom.tour.findByIdAsync({
          id: this.mData.tableRules.dataSearch.value.tour_id,
        });
        this.mData.dataDefault.listFindTour.push(res.result);
        this.ten_tour = res.result.ten_tour;
        // this.querySearch(this.ten_tour);
        // this.handleSelect(item);
      }
      // if (this.mData.tableRules.dataSearch.value.huong_dan_vien_ids) {
      //   let resHDV = await HuongDanVienApi.findById(
      //     this.mData.tableRules.dataSearch.value.huong_dan_vien_ids
      //   );
      //   this.mData.dataDefault.listFindHuongDanVien.push(resHDV.result);
      //   this.ho_ten_Hdv = resHDV.result.ho_ten.ho_ten;
      // }
    },
  },

  //run after render view
  created() {
    this.fn_hashUrl();
  },
  mounted() {
    this.fn_initTable();
  },
};
</script>

<style lang="scss">
.status-tag {
  display: inline-block;
  padding: 1px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: bold;
}

.status-draft {
  color: #595959;
  background-color: #f5f5f5;
}

.status-signing {
  color: #096dd9;
  background-color: #e6f4ff;
}

.status-signed {
  color: #389e0d;
  background-color: #f6ffed;
}

.status-cancelled {
  color: #8c8c8c;
  background-color: #fafafa;
}

.status-rejected {
  color: #cf1322;
  background-color: #fff1f0;
}
.iframe-dialog .el-dialog {
  height: 85vh; /* dialog cao 80% màn hình */
  width: 90%;
  max-width: 1300px;
  display: flex;
  flex-direction: column;
}

.iframe-dialog .el-dialog__body {
  flex: 1;
  padding: 0;
}

.iframe-wrapper {
  height: 100%;
}

.iframe-contract {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
